import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { setFocusElement, toggleRightDrawer } from '../../../store/global/actions';
import { useHistory } from "react-router-dom";
import { constructIds } from '../../../config/common';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Hyperlink from '../../atoms/links/Hyperlink';
import Strip from '../../atoms/Wrappers/Strip';
import { StyledTableCellHead } from '../../atoms/table/tableStyles';
import { SearchTextField } from '../blueprint/SearchField';
import { stableSort, getComparator } from '../../../services/entities/common';
import { invokeGetService } from '../../../store/global/actions'
import TransactionDialog from '../alerts/CreateTransactionAlert';

export default function ListTransactions({ element }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [openAddTransactionDialog, setOpenAddTransactionDialog] = useState(false);

    useEffect(() => {
        setLoading(true);
        dispatch(invokeGetService('getAssociatedTransactions', [element.id, 1])).then(res => {
            if (res?.status) {
                setTransactions(res?.data?.filter(row => (row.name.toLowerCase().includes(searchQuery.toLowerCase()) || row.description.toLowerCase().includes(searchQuery.toLowerCase()))))
            }
            setLoading(false);
        });
    }, [searchQuery])


    const onEdit = ({ item }) => {
        const [, , slug, id, currentTag] = history.location.pathname.split("/");
        // history.push(`/blueprint/${slug}/${id}/information_flow/${item._id}`);
        history.push(`/blueprint/${slug}/${id}/transaction/${item._id}`);
        dispatch(setFocusElement({
            id: item._id,
            type: constructIds.find(x => x.id === item.type).name,
            category: 'editNormal' //for distinguish the edit form in right drawer
        }))
    }

    const createTransaction = () => {
        setOpenAddTransactionDialog(true);
    };

    return (
        <>

            <SearchTextField setSearchQuery={setSearchQuery} searchQuery={searchQuery} />

            <TableContainer component={Paper} style={{borderRadius: "0", boxShadow: 'none'}}>
                <Table aria-label="customized table" >
                    <TableHead>
                        <TableRow>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'name'}> Name </StyledTableCellHead>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'description'}>Description</StyledTableCellHead>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {
                            loading ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                        Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                    </StyledTableCell>
                                </StyledTableRow>
                                : transactions.length < 1 ?
                                    <StyledTableRow>
                                        <StyledTableCell align={'center'} colSpan={4} component="td" style={{ padding: 15 }}>
                                            No transactions available. <a href='#' onClick={createTransaction}>Create a new transaction</a>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                    : stableSort(transactions, getComparator(order, orderBy))?.map((trans, index) => (
                                        <StyledTableRow key={trans.name}>

                                            <StyledTableCell align={'left'} component="td" >
                                                {/* <Hyperlink id={trans._id} transactionId={trans._id} type={'transaction'} screen={'information_flow'} > {trans.name} </Hyperlink> */}
                                                <Hyperlink id={trans._id} name={trans.name} transactionId={trans._id} type={'transaction'} screen={'transaction'} > {trans.name} </Hyperlink>
                                                {/* <div dangerouslySetInnerHTML={{ __html: trans?.name?.replace(searchQuery, match => `<span style="color:red">${match}</span>`) }} /> */}
                                            </StyledTableCell>

                                            <Tooltip title={trans.description}>
                                                <StyledTableCell align={'left'} component="td">
                                                    <Strip >{trans.description}</Strip>
                                                </StyledTableCell>
                                            </Tooltip>

                                        </StyledTableRow>
                                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {openAddTransactionDialog && <TransactionDialog onClose={() => setOpenAddTransactionDialog(false)}/>}

        </>
    )
}
